import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class JobsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'project_name'
      },
      {
        title: 'Address',
        dataIndex: 'address'
      },
      {
        title: 'Company',
        dataIndex: 'company'
      },
      {
        title: 'Primary Contact',
        dataIndex: 'primary_contact'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { jobsAddedData } = this.props

    const data = jobsAddedData.map((job, index) => {
      // format date from db
      job.created_date = moment(new Date(job.created_date)).format('YYYY-M-D h:mm a')

      // format address
      job.address = `${job.address1 !== null && job.address1}${
        job.address2 !== null ? ' ' + job.address2 : ''
      }${job.city !== null ? ', ' + job.city : ''}${job.state !== null ? ' - ' + job.state : ''}${
        job.zip !== null ? ' - ' + job.zip : ''
      }`

      // format primary contact name
      job.primary_contact = `${job.contact_first_name} ${job.contact_last_name}`

      const returnObj = Object.assign({ key: `${job.id}${index}` }, job)
      delete returnObj.id
      return returnObj
    })
    return data
  }

  render() {
    const { loadingJobsAdded, jobsAddedData } = this.props
    return (
      <div>
        {loadingJobsAdded && !jobsAddedData && <Spin />}
        {!loadingJobsAdded &&
          jobsAddedData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default JobsAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/JobsAdded.js